import { render, staticRenderFns } from "./RecentActivitiesWidget.vue?vue&type=template&id=af8719b6&scoped=true"
import script from "./RecentActivitiesWidget.vue?vue&type=script&lang=js"
export * from "./RecentActivitiesWidget.vue?vue&type=script&lang=js"
import style0 from "./RecentActivitiesWidget.vue?vue&type=style&index=0&id=af8719b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8719b6",
  null
  
)

export default component.exports